export const getBaseUrl = () => {
  const env = process.env.GATSBY_ENVIRONMENT || 'development';
  switch (env) {
    case 'development':
    default:
      return 'https://www.lendi-dev.net';
    case 'staging':
      return 'https://www.lendi-stg.net';
    case 'preproduction':
      return 'https://www.lendi-preprod.net';
    case 'production':
      return 'https://www.lendi.com.au';
  }
};

export const getUrlByEnvironment = (link: string | undefined): string => {
  if (!link) return '';

  if (/^(tel|mailto):/.test(link)) {
    return link;
  }

  try {
    const formattedAbsoluteLink = /^(www|lendi)(\.|-)/.test(link) ? `https://${link}` : link;
    const url = new URL(formattedAbsoluteLink);
    return new URL(url.pathname, getBaseUrl()).href;
  } catch (e) {
    return link;
  }
};
